/**
An element providing a solution to no problem in particular.

Example Web Component:

    <button is="com-button" theme="primary">Hello World</button>

Example CSS Class:

    <a class="com-button" theme="primary">Hello World</a>

@group Seed Elements
@element com-button
@demo demo/index.html
*/
import { PolymerElement, html } from '@polymer/polymer';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { IronButtonState } from '@polymer/iron-behaviors/iron-button-state.js';
import { IronControlState } from '@polymer/iron-behaviors/iron-control-state.js';

import './style/com-button-style.js';

/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
class COMButton extends mixinBehaviors([
  IronButtonState,
  IronControlState
], PolymerElement) {
  static get template() {
    return html`
    <style include="com-button-style"></style>
    <slot></slot>
`;
  }

  static get is() { return 'com-button'; }

  static get properties() {
    return {
      /**
      * The theme of the button
      **/
      theme: {
        type: String,
        value: 'primary',
        reflectToAttribute: true
      },
      role: {
        type: String,
        value: 'button',
        reflectToAttribute: true
      },
      tabindex: {
        type: Number,
        value: 0,
        reflectToAttribute: true
      }
    }
  }
}
customElements.define(COMButton.is, COMButton);
